import { useQuery } from '@tanstack/react-query';
import { USER_PROFILES_IMAGE_KEY } from '../../utils/constants/queryKeys';
import { getUserProfilesImage } from '../services/fn-api/User';

export const useGetUserProfilesImage = (userId?: number) => {
  return useQuery({
    queryKey: [USER_PROFILES_IMAGE_KEY, userId],
    queryFn: async () => {
      if (userId === undefined) throw new Error('User ID is required');
      return getUserProfilesImage(userId);
    },
    enabled: !!userId,
  });
};
